import { JsonReadOptions, JsonWriteOptions } from '@protobuf-ts/runtime'

export const defaultJSONOptions: Partial<JsonWriteOptions> = {
  useProtoFieldName: false,
  emitDefaultValues: false,
}

// Use this as Message.fromJson(message, defaultJSONDecodeOptions) to avoid proto decoding failure
// in case of disparity between front-end and back-end proto versions
export const defaultJSONDecodeOptions: Partial<JsonReadOptions> = {
  ignoreUnknownFields: true,
}
